import coreCollections from './core';


const {
  average,
  constructsUsing,
  copyGenerator,
  count,
  deepCopy,
  deepEquals,
  entries,
  getAt,
  groupBy,
  hasKey,
  isCollection,
  isIterable,
  iterate,
  keys,
  makeShapeTemplate,
  setAt,
  updateAt,
  valueCopy,
  valueEquals,
  valueForKey,
  valueGetters,
  values,
  yieldableFor,
  sum,
} = coreCollections;

export {
  average,
  constructsUsing,
  copyGenerator,
  count,
  deepCopy,
  deepEquals,
  entries,
  getAt,
  groupBy,
  hasKey,
  isCollection,
  isIterable,
  iterate,
  keys,
  makeShapeTemplate,
  setAt,
  updateAt,
  valueCopy,
  valueEquals,
  valueForKey,
  valueGetters,
  values,
  yieldableFor,
  sum,
};




// WEBPACK FOOTER //
// ./lib/rlink-collections/index.js